<template>
  <v-text-field
    v-model="localValue"
    :rules=[decimalRule]
    outlined
    clearable
    hide-details
    :append-icon="appendIcon"
    class="custom-prefix-one-letter"
    @blur="onBlur"
  />
</template>
  <script>
  export default {
    name: "DecimalNumberInput",
    props: {
      value: [String, Number],
      appendIcon: String
    },
    data() {
      return {
        localValue: this.value
      };
    },
    watch: {
      value(val) {
        this.localValue = val;
      },
      localValue(val) {
        this.$emit("input", val);
      }
    },
    methods: {
      onBlur() {
        const num = this.localValue;
        if (!isNaN(num)) {
          this.localValue = num;
        }
      }
    },
    computed: {
      decimalRule() {
        return (v) =>
          v === null ||
          /^-?\d+(\.\d{1,2})?$/.test(v) ||
          "Nur Zahlen mit bis zu zwei Dezimalstellen erlaubt";
      }
    }
  };
  </script>  